import React, { useEffect, useState, useRef, Fragment, Component } from 'react';
import { Card } from './ui/Card';
import { Eye, Download, ChevronDown, Check, X, Filter, Info, Building2, Shield, AlertTriangle } from 'lucide-react';
import { Link } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';
interface SiteData {
  id: string;
  siteName: string;
  complianceScore: number;
  riskScore: number;
  acConnectivity: boolean;
  workerIssues: number;
  openObservations: number;
  incompletePreShift: number | 'N/A';
  incompleteToolboxTalk: number | 'N/A';
  incompleteJHA: number | 'N/A';
  incompletePTP: number | 'N/A';
  documentsExpiringSoon: number;
  expired: number;
  inspectionsLogs: number;
  workerListReport: boolean;
  dailySiteReport: boolean;
  qrPoster: boolean;
}
interface FeatureAdoption {
  manpowerOrientations: 'active' | 'partial' | 'inactive';
  permits: 'active' | 'partial' | 'inactive';
  accessControl: 'active' | 'partial' | 'inactive';
  preShifts: 'active' | 'partial' | 'inactive';
  toolboxTalks: 'active' | 'partial' | 'inactive';
  inspectionsLogs: 'active' | 'partial' | 'inactive';
  procoreIntegration: 'active' | 'partial' | 'inactive';
  comment?: string;
}
interface ProjectData {
  id: string;
  projectName: string;
  features: FeatureAdoption;
}
const MOCK_SITES: SiteData[] = [{
  id: '1',
  siteName: '1678 Lexington Ave',
  complianceScore: 82,
  riskScore: 28,
  acConnectivity: true,
  workerIssues: 0,
  openObservations: 0,
  incompletePreShift: 1,
  incompleteToolboxTalk: 2,
  incompleteJHA: 0,
  incompletePTP: 'N/A',
  documentsExpiringSoon: 0,
  expired: 0,
  inspectionsLogs: 0,
  workerListReport: true,
  dailySiteReport: true,
  qrPoster: true
}, {
  id: '2',
  siteName: '450 Park Avenue South',
  complianceScore: 64,
  riskScore: 45,
  acConnectivity: true,
  workerIssues: 0,
  openObservations: 31,
  incompletePreShift: 0,
  incompleteToolboxTalk: 2,
  incompleteJHA: 3,
  incompletePTP: 0,
  documentsExpiringSoon: 0,
  expired: 0,
  inspectionsLogs: 5,
  workerListReport: true,
  dailySiteReport: true,
  qrPoster: true
}, {
  id: '3',
  siteName: '520 Fifth Avenue',
  complianceScore: 71,
  riskScore: 32,
  acConnectivity: true,
  workerIssues: 0,
  openObservations: 0,
  incompletePreShift: 0,
  incompleteToolboxTalk: 'N/A',
  incompleteJHA: 'N/A',
  incompletePTP: 'N/A',
  documentsExpiringSoon: 0,
  expired: 0,
  inspectionsLogs: 0,
  workerListReport: true,
  dailySiteReport: false,
  qrPoster: true
}, {
  id: '4',
  siteName: '88 Greenwich Street',
  complianceScore: 76,
  riskScore: 35,
  acConnectivity: true,
  workerIssues: 0,
  openObservations: 0,
  incompletePreShift: 0,
  incompleteToolboxTalk: 'N/A',
  incompleteJHA: 'N/A',
  incompletePTP: 'N/A',
  documentsExpiringSoon: 0,
  expired: 0,
  inspectionsLogs: 2,
  workerListReport: true,
  dailySiteReport: true,
  qrPoster: false
}, {
  id: '5',
  siteName: '333 Schermerhorn St',
  complianceScore: 91,
  riskScore: 18,
  acConnectivity: true,
  workerIssues: 0,
  openObservations: 0,
  incompletePreShift: 0,
  incompleteToolboxTalk: 0,
  incompleteJHA: 0,
  incompletePTP: 0,
  documentsExpiringSoon: 0,
  expired: 0,
  inspectionsLogs: 0,
  workerListReport: false,
  dailySiteReport: true,
  qrPoster: true
}, {
  id: '16',
  siteName: 'Harlem River Towers',
  complianceScore: 94,
  riskScore: 71,
  acConnectivity: true,
  workerIssues: 0,
  openObservations: 2,
  incompletePreShift: 0,
  incompleteToolboxTalk: 0,
  incompleteJHA: 0,
  incompletePTP: 0,
  documentsExpiringSoon: 0,
  expired: 0,
  inspectionsLogs: 0,
  workerListReport: true,
  dailySiteReport: true,
  qrPoster: true
}, {
  id: '6',
  siteName: '15 Hudson Yards',
  complianceScore: 85,
  riskScore: 24,
  acConnectivity: true,
  workerIssues: 0,
  openObservations: 2,
  incompletePreShift: 0,
  incompleteToolboxTalk: 0,
  incompleteJHA: 0,
  incompletePTP: 0,
  documentsExpiringSoon: 0,
  expired: 0,
  inspectionsLogs: 1,
  workerListReport: true,
  dailySiteReport: true,
  qrPoster: true
}, {
  id: '7',
  siteName: '200 Liberty Street',
  complianceScore: 88,
  riskScore: 22,
  acConnectivity: true,
  workerIssues: 0,
  openObservations: 0,
  incompletePreShift: 0,
  incompleteToolboxTalk: 'N/A',
  incompleteJHA: 'N/A',
  incompletePTP: 'N/A',
  documentsExpiringSoon: 0,
  expired: 0,
  inspectionsLogs: 0,
  workerListReport: true,
  dailySiteReport: true,
  qrPoster: true
}, {
  id: '8',
  siteName: '1 Willoughby Square',
  complianceScore: 58,
  riskScore: 52,
  acConnectivity: true,
  workerIssues: 0,
  openObservations: 46,
  incompletePreShift: 0,
  incompleteToolboxTalk: 0,
  incompleteJHA: 0,
  incompletePTP: 0,
  documentsExpiringSoon: 0,
  expired: 0,
  inspectionsLogs: 3,
  workerListReport: true,
  dailySiteReport: true,
  qrPoster: true
}, {
  id: '9',
  siteName: 'Court Square LIC',
  complianceScore: 38,
  riskScore: 72,
  acConnectivity: true,
  workerIssues: 2,
  openObservations: 5,
  incompletePreShift: 1,
  incompleteToolboxTalk: 0,
  incompleteJHA: 1,
  incompletePTP: 2,
  documentsExpiringSoon: 8,
  expired: 20,
  inspectionsLogs: 1,
  workerListReport: true,
  dailySiteReport: true,
  qrPoster: true
}, {
  id: '10',
  siteName: '99 Claremont Ave',
  complianceScore: 45,
  riskScore: 65,
  acConnectivity: true,
  workerIssues: 1,
  openObservations: 3,
  incompletePreShift: 0,
  incompleteToolboxTalk: 0,
  incompleteJHA: 0,
  incompletePTP: 1,
  documentsExpiringSoon: 7,
  expired: 18,
  inspectionsLogs: 1,
  workerListReport: true,
  dailySiteReport: true,
  qrPoster: true
}, {
  id: '11',
  siteName: '251 Douglass Street',
  complianceScore: 52,
  riskScore: 58,
  acConnectivity: true,
  workerIssues: 0,
  openObservations: 1,
  incompletePreShift: 0,
  incompleteToolboxTalk: 1,
  incompleteJHA: 1,
  incompletePTP: 1,
  documentsExpiringSoon: 10,
  expired: 22,
  inspectionsLogs: 1,
  workerListReport: true,
  dailySiteReport: true,
  qrPoster: true
}, {
  id: '12',
  siteName: 'Brooklyn Heights Project',
  complianceScore: 55,
  riskScore: 54,
  acConnectivity: true,
  workerIssues: 1,
  openObservations: 8,
  incompletePreShift: 2,
  incompleteToolboxTalk: 1,
  incompleteJHA: 0,
  incompletePTP: 0,
  documentsExpiringSoon: 5,
  expired: 12,
  inspectionsLogs: 2,
  workerListReport: true,
  dailySiteReport: true,
  qrPoster: true
}, {
  id: '13',
  siteName: 'Queens Plaza Development',
  complianceScore: 48,
  riskScore: 61,
  acConnectivity: true,
  workerIssues: 0,
  openObservations: 12,
  incompletePreShift: 0,
  incompleteToolboxTalk: 2,
  incompleteJHA: 2,
  incompletePTP: 'N/A',
  documentsExpiringSoon: 3,
  expired: 8,
  inspectionsLogs: 4,
  workerListReport: true,
  dailySiteReport: false,
  qrPoster: true
}, {
  id: '14',
  siteName: 'Bronx Commercial Center',
  complianceScore: 31,
  riskScore: 78,
  acConnectivity: false,
  workerIssues: 3,
  openObservations: 15,
  incompletePreShift: 3,
  incompleteToolboxTalk: 3,
  incompleteJHA: 2,
  incompletePTP: 2,
  documentsExpiringSoon: 12,
  expired: 25,
  inspectionsLogs: 0,
  workerListReport: true,
  dailySiteReport: true,
  qrPoster: false
}, {
  id: '15',
  siteName: 'Staten Island Warehouse',
  complianceScore: 60,
  riskScore: 48,
  acConnectivity: true,
  workerIssues: 0,
  openObservations: 4,
  incompletePreShift: 1,
  incompleteToolboxTalk: 0,
  incompleteJHA: 0,
  incompletePTP: 1,
  documentsExpiringSoon: 6,
  expired: 14,
  inspectionsLogs: 2,
  workerListReport: true,
  dailySiteReport: true,
  qrPoster: true
}];
const MOCK_PROJECTS: ProjectData[] = [{
  id: '1',
  projectName: 'Court Square LIC',
  features: {
    manpowerOrientations: 'active',
    permits: 'partial',
    accessControl: 'active',
    preShifts: 'active',
    toolboxTalks: 'partial',
    inspectionsLogs: 'active',
    procoreIntegration: 'active',
    comment: 'Not all foremen performing Toolbox'
  }
}, {
  id: '2',
  projectName: '99 Claremont Ave',
  features: {
    manpowerOrientations: 'active',
    permits: 'inactive',
    accessControl: 'active',
    preShifts: 'partial',
    toolboxTalks: 'inactive',
    inspectionsLogs: 'active',
    procoreIntegration: 'active',
    comment: 'No ToolBox talks performed last week. No Permits added'
  }
}, {
  id: '3',
  projectName: '251 Douglass Street',
  features: {
    manpowerOrientations: 'active',
    permits: 'active',
    accessControl: 'active',
    preShifts: 'active',
    toolboxTalks: 'active',
    inspectionsLogs: 'active',
    procoreIntegration: 'active'
  }
}, {
  id: '4',
  projectName: '450 Park Avenue South',
  features: {
    manpowerOrientations: 'active',
    permits: 'partial',
    accessControl: 'active',
    preShifts: 'partial',
    toolboxTalks: 'inactive',
    inspectionsLogs: 'partial',
    procoreIntegration: 'active',
    comment: '- Stopped using logs end of Oct\n- No use of Toolbox talk'
  }
}];
interface MetricRow {
  id: string;
  label: string;
  category: 'safety' | 'compliance' | 'documents' | 'reports';
  getValue: (site: SiteData) => number | boolean | 'N/A';
  type: 'number' | 'boolean' | 'download';
  contractorIgnored?: boolean;
  getLink?: (site: SiteData) => string;
}
const METRICS: MetricRow[] = [{
  id: 'acConnectivity',
  label: 'AC Connectivity',
  category: 'safety',
  getValue: site => site.acConnectivity,
  type: 'boolean'
}, {
  id: 'workerIssues',
  label: 'Worker Issues',
  category: 'safety',
  getValue: site => site.workerIssues,
  type: 'number'
}, {
  id: 'openObservations',
  label: 'Open Observations',
  category: 'safety',
  getValue: site => site.openObservations,
  type: 'number'
}, {
  id: 'incompletePreShift',
  label: 'Incomplete Pre-Shift Today',
  category: 'compliance',
  getValue: site => site.incompletePreShift,
  type: 'number',
  getLink: site => `/pre-shift?site=${encodeURIComponent(site.siteName)}&period=today&status=incomplete`
}, {
  id: 'incompleteToolboxTalk',
  label: 'Incomplete Toolbox Talk',
  category: 'compliance',
  getValue: site => site.incompleteToolboxTalk,
  type: 'number',
  getLink: site => `/toolbox-talk?site=${encodeURIComponent(site.siteName)}&period=thisweek&status=incomplete`
}, {
  id: 'incompleteJHA',
  label: 'Incomplete JHA Today',
  category: 'compliance',
  getValue: site => site.incompleteJHA,
  type: 'number',
  getLink: site => `/jha?site=${encodeURIComponent(site.siteName)}&period=entireproject&status=incomplete`
}, {
  id: 'incompletePTP',
  label: 'Incomplete PTP Today',
  category: 'compliance',
  getValue: site => site.incompletePTP,
  type: 'number',
  getLink: site => `/ptp?site=${encodeURIComponent(site.siteName)}&period=today&status=incomplete`
}, {
  id: 'documentsExpiringSoon',
  label: 'Documents Expiring Soon',
  category: 'documents',
  getValue: site => site.documentsExpiringSoon,
  type: 'number',
  contractorIgnored: true,
  getLink: site => `/documents?site=${encodeURIComponent(site.siteName)}&status=expiring-soon`
}, {
  id: 'expired',
  label: 'Expired Documents',
  category: 'documents',
  getValue: site => site.expired,
  type: 'number',
  contractorIgnored: true,
  getLink: site => `/documents?site=${encodeURIComponent(site.siteName)}&status=expired`
}, {
  id: 'inspectionsLogs',
  label: 'Inspections & Logs',
  category: 'safety',
  getValue: site => site.inspectionsLogs,
  type: 'number',
  contractorIgnored: true,
  getLink: site => `/inspections?site=${encodeURIComponent(site.siteName)}&period=today&status=incomplete`
}, {
  id: 'workerListReport',
  label: 'Worker List Report',
  category: 'reports',
  getValue: site => site.workerListReport,
  type: 'download'
}, {
  id: 'dailySiteReport',
  label: 'Daily Site Report',
  category: 'reports',
  getValue: site => site.dailySiteReport,
  type: 'download'
}, {
  id: 'qrPoster',
  label: 'QR Poster',
  category: 'reports',
  getValue: site => site.qrPoster,
  type: 'download'
}];
const CATEGORY_LABELS = {
  safety: 'Safety Metrics',
  compliance: 'Daily Compliance',
  documents: 'Documents',
  reports: 'Reports & Downloads'
};
const FEATURE_LABELS = {
  manpowerOrientations: 'Manpower and Orientations',
  permits: 'Permits',
  accessControl: 'Access Control',
  preShifts: 'Pre-Shifts',
  toolboxTalks: 'ToolBox Talks',
  inspectionsLogs: 'Inspections & Logs',
  procoreIntegration: 'Procore Integration'
};
type TabType = 'site-health' | 'feature-adoption';
interface SitesOverviewTableProps {
  isFiltered?: boolean;
  isProjectFiltered?: boolean;
  isContractorFiltered?: boolean;
  selectedSites?: string[];
}
// Helper to get score color classes
function getScoreColor(score: number): {
  bg: string;
  text: string;
  barBg: string;
} {
  if (score >= 70) return {
    bg: 'bg-emerald-50',
    text: 'text-emerald-700',
    barBg: 'bg-emerald-500'
  };
  if (score >= 50) return {
    bg: 'bg-amber-50',
    text: 'text-amber-700',
    barBg: 'bg-amber-500'
  };
  if (score >= 30) return {
    bg: 'bg-orange-50',
    text: 'text-orange-700',
    barBg: 'bg-orange-500'
  };
  return {
    bg: 'bg-red-50',
    text: 'text-red-700',
    barBg: 'bg-red-500'
  };
}
function getRiskColor(score: number): {
  bg: string;
  text: string;
  barBg: string;
} {
  if (score <= 30) return {
    bg: 'bg-emerald-50',
    text: 'text-emerald-700',
    barBg: 'bg-emerald-500'
  };
  if (score <= 50) return {
    bg: 'bg-amber-50',
    text: 'text-amber-700',
    barBg: 'bg-amber-500'
  };
  if (score <= 70) return {
    bg: 'bg-orange-50',
    text: 'text-orange-700',
    barBg: 'bg-orange-500'
  };
  return {
    bg: 'bg-red-50',
    text: 'text-red-700',
    barBg: 'bg-red-500'
  };
}
export function SitesOverviewTable({
  isFiltered,
  isProjectFiltered,
  isContractorFiltered,
  selectedSites
}: SitesOverviewTableProps) {
  const [activeTab, setActiveTab] = useState<TabType>('site-health');
  const [collapsedCategories, setCollapsedCategories] = useState<Set<string>>(new Set());
  const [hoveredColumn, setHoveredColumn] = useState<string | null>(null);
  const [showScrollIndicator, setShowScrollIndicator] = useState(true);
  const [hasScrolledOnce, setHasScrolledOnce] = useState(false);
  const [showDisabledTooltip, setShowDisabledTooltip] = useState(false);
  const tableContainerRef = useRef<HTMLDivElement>(null);
  // Feature Adoption is hidden when contractor filter is active
  const isFeatureAdoptionDisabled = !!isContractorFiltered;
  // Filter sites based on selected sites (project filter)
  const filteredSites = isProjectFiltered && selectedSites ? MOCK_SITES.filter(site => selectedSites.includes(site.siteName)) : MOCK_SITES;
  // For feature adoption, show all projects (no site-to-project mapping in mock data)
  const filteredProjects = MOCK_PROJECTS;
  // Auto-switch to Site Health if Feature Adoption becomes unavailable
  useEffect(() => {
    if (isFeatureAdoptionDisabled && activeTab === 'feature-adoption') {
      setActiveTab('site-health');
    }
  }, [isFeatureAdoptionDisabled, activeTab]);
  useEffect(() => {
    const container = tableContainerRef.current;
    if (!container) return;
    const handleScroll = () => {
      if (!hasScrolledOnce && container.scrollTop > 20) {
        setHasScrolledOnce(true);
        setShowScrollIndicator(false);
      }
    };
    container.addEventListener('scroll', handleScroll);
    return () => container.removeEventListener('scroll', handleScroll);
  }, [hasScrolledOnce]);
  // Check if content is scrollable
  useEffect(() => {
    const container = tableContainerRef.current;
    if (!container) return;
    const isScrollable = container.scrollHeight > container.clientHeight;
    setShowScrollIndicator(isScrollable && !hasScrolledOnce);
  }, [collapsedCategories, hasScrolledOnce, activeTab]);
  const toggleCategory = (category: string) => {
    setCollapsedCategories(prev => {
      const newSet = new Set(prev);
      if (newSet.has(category)) {
        newSet.delete(category);
      } else {
        newSet.add(category);
      }
      return newSet;
    });
  };
  const renderCell = (value: number | boolean | 'N/A', type: 'number' | 'boolean' | 'download', link?: string) => {
    if (value === 'N/A') {
      return <div className="flex items-center justify-center h-full" data-id="element-3839">
          <span className="text-xs text-gray-400 font-medium" data-id="element-3840">N/A</span>
        </div>;
    }
    if (type === 'boolean') {
      return <div className="flex items-center justify-center h-full" data-id="element-3841">
          <div className={`w-3 h-3 rounded-full ${value ? 'bg-emerald-500' : 'bg-gray-300'}`} data-id="element-3842" />
        </div>;
    }
    if (type === 'download') {
      return <div className="flex items-center justify-center h-full" data-id="element-3843">
          {value ? <button className="text-gray-400 hover:text-emerald-600 transition-colors p-1" data-id="element-3844">
              <Download size={16} data-id="element-3845" />
            </button> : <span className="text-gray-300" data-id="element-3846">-</span>}
        </div>;
    }
    // Number type
    const numValue = value as number;
    if (numValue === 0) {
      return <div className="flex items-center justify-center h-full" data-id="element-3847">
          <span className="text-emerald-600 font-semibold" data-id="element-3848">{numValue}</span>
        </div>;
    }
    const content = <span className="inline-flex items-center justify-center min-w-[28px] h-6 px-2 bg-red-100 text-red-700 rounded text-sm font-bold" data-id="element-3849">
        {numValue}
      </span>;
    if (link) {
      return <div className="flex items-center justify-center h-full" data-id="element-3850">
          <Link to={link} className="hover:opacity-80 transition-opacity hover:scale-110 transform duration-200" data-id="element-3851">
            {content}
          </Link>
        </div>;
    }
    return <div className="flex items-center justify-center h-full" data-id="element-3852">{content}</div>;
  };
  const renderFeatureStatus = (status: 'active' | 'partial' | 'inactive') => {
    if (status === 'active') {
      return <div className="flex items-center justify-center" data-id="element-3853">
          <div className="w-8 h-8 rounded-full bg-emerald-500 flex items-center justify-center" data-id="element-3854">
            <Check size={20} className="text-white" strokeWidth={3} data-id="element-3855" />
          </div>
        </div>;
    }
    if (status === 'partial') {
      return <div className="flex items-center justify-center" data-id="element-3856">
          <div className="w-8 h-8 rounded-full bg-amber-500 flex items-center justify-center" data-id="element-3857">
            <Check size={20} className="text-white" strokeWidth={3} data-id="element-3858" />
          </div>
        </div>;
    }
    return <div className="flex items-center justify-center" data-id="element-3859">
        <div className="w-8 h-8 rounded-full bg-red-500 flex items-center justify-center" data-id="element-3860">
          <X size={20} className="text-white" strokeWidth={3} data-id="element-3861" />
        </div>
      </div>;
  };
  const groupedMetrics = METRICS.reduce((acc, metric) => {
    if (!acc[metric.category]) {
      acc[metric.category] = [];
    }
    acc[metric.category].push(metric);
    return acc;
  }, {} as Record<string, MetricRow[]>);
  return <Card data-id="element-3862">
      <div className="flex items-center justify-between mb-6" data-id="element-3863">
        <div className="flex items-center gap-3" data-id="element-3864">
          <h2 className="text-lg font-bold text-gray-900" data-id="element-3865">
            Your sites at a glance
          </h2>
          {isFiltered && <motion.div initial={{
          opacity: 0,
          scale: 0.8
        }} animate={{
          opacity: 1,
          scale: 1
        }} className="flex items-center gap-1 bg-amber-100 text-amber-700 text-[10px] font-bold uppercase tracking-wide px-2 py-0.5 rounded-full" data-id="element-3866">
              <Filter size={10} data-id="element-3867" />
              Filtered
            </motion.div>}
        </div>
        <button className="flex items-center gap-2 text-sm text-gray-600 hover:text-gray-900 transition-colors" data-id="element-3868">
          <Eye size={16} data-id="element-3869" />
          View all
        </button>
      </div>

      {/* Tabs */}
      <div className="mb-6 border-b border-gray-200" data-id="element-3870">
        <div className="flex gap-8 relative" data-id="element-3871">
          <button onClick={() => setActiveTab('site-health')} className={`pb-3 text-sm font-semibold transition-colors relative ${activeTab === 'site-health' ? 'text-gray-900' : 'text-gray-500 hover:text-gray-700'}`} data-id="element-3872">
            Site Health
            {activeTab === 'site-health' && <motion.div layoutId="activeTab" className="absolute bottom-0 left-0 right-0 h-0.5 bg-emerald-600" transition={{
            type: 'spring',
            stiffness: 500,
            damping: 30
          }} data-id="element-3873" />}
          </button>

          {/* Feature Adoption tab — disabled when contractor-filtered */}
          <div className="relative" data-id="element-3874">
            <button onClick={() => {
            if (!isFeatureAdoptionDisabled) {
              setActiveTab('feature-adoption');
            }
          }} onMouseEnter={() => isFeatureAdoptionDisabled && setShowDisabledTooltip(true)} onMouseLeave={() => setShowDisabledTooltip(false)} className={`pb-3 text-sm font-semibold transition-colors relative ${isFeatureAdoptionDisabled ? 'text-gray-300 cursor-not-allowed' : activeTab === 'feature-adoption' ? 'text-gray-900' : 'text-gray-500 hover:text-gray-700'}`} data-id="element-3875">
              <span className="flex items-center gap-1.5" data-id="element-3876">
                Feature Adoption
                {isFeatureAdoptionDisabled && <Info size={14} className="text-gray-300" data-id="element-3877" />}
              </span>
              {activeTab === 'feature-adoption' && !isFeatureAdoptionDisabled && <motion.div layoutId="activeTab" className="absolute bottom-0 left-0 right-0 h-0.5 bg-emerald-600" transition={{
              type: 'spring',
              stiffness: 500,
              damping: 30
            }} data-id="element-3878" />}
            </button>

            {/* Tooltip for disabled state */}
            <AnimatePresence data-id="element-3879">
              {showDisabledTooltip && <motion.div initial={{
              opacity: 0,
              y: 4
            }} animate={{
              opacity: 1,
              y: 0
            }} exit={{
              opacity: 0,
              y: 4
            }} transition={{
              duration: 0.15
            }} className="absolute top-full mt-2 left-1/2 -translate-x-1/2 z-50 w-56 bg-gray-900 text-white text-xs rounded-lg px-3 py-2 shadow-lg pointer-events-none" data-id="element-3880">
                  <div className="absolute -top-1 left-1/2 -translate-x-1/2 w-2 h-2 bg-gray-900 rotate-45" data-id="element-3881" />
                  Feature Adoption is not available when filtering by
                  contractor.
                </motion.div>}
            </AnimatePresence>
          </div>
        </div>
      </div>

      <div ref={tableContainerRef} className="overflow-x-auto overflow-y-auto max-h-[600px] -mx-6 px-6 relative" data-id="element-3882">
        <AnimatePresence mode="wait" data-id="element-3883">
          {activeTab === 'site-health' ? <motion.div key="site-health" initial={{
          opacity: 0,
          y: 10
        }} animate={{
          opacity: 1,
          y: 0
        }} exit={{
          opacity: 0,
          y: -10
        }} transition={{
          duration: 0.2
        }} data-id="element-3884">
              <table className="w-full text-sm border-collapse" data-id="element-3885">
                {/* Header Row - Site Names */}
                <thead className="sticky top-0 z-20 bg-white" data-id="element-3886">
                  <tr className="border-b-2 border-gray-200" data-id="element-3887">
                    <th className="sticky left-0 z-30 bg-white py-4 px-4 text-left min-w-[240px]" data-id="element-3888">
                      <span className="text-xs font-semibold text-gray-500 uppercase tracking-wider" data-id="element-3889">
                        Metric
                      </span>
                    </th>
                    {filteredSites.map(site => <th key={site.id} className={`py-4 px-3 text-center min-w-[120px] align-top transition-colors ${hoveredColumn === site.id ? 'bg-gray-50' : ''}`} onMouseEnter={() => setHoveredColumn(site.id)} onMouseLeave={() => setHoveredColumn(null)} data-id="element-3890">
                        <div className="flex flex-col items-center gap-2" data-id="element-3891">
                          <div className="w-10 h-10 bg-gray-100 rounded-lg flex items-center justify-center flex-shrink-0" data-id="element-3892">
                            <Building2 size={20} className="text-gray-400" data-id="element-3893" />
                          </div>
                          <span className="text-xs font-semibold text-gray-900 text-center leading-tight max-w-[100px]" data-id="element-3894">
                            {site.siteName}
                          </span>
                        </div>
                      </th>)}
                  </tr>
                </thead>

                <tbody data-id="element-3895">
                  {/* Score Rows - Compliance Score & Risk Score */}
                  <tr className="bg-gray-50 border-t border-gray-200" data-id="element-3896">
                    <td colSpan={filteredSites.length + 1} className="sticky left-0 z-10 bg-gray-50" data-id="element-3897">
                      <div className="flex items-center gap-2 py-3 px-4" data-id="element-3898">
                        <span className="text-xs font-bold text-gray-700 uppercase tracking-wider" data-id="element-3899">
                          Scores
                        </span>
                        <span className="text-xs text-gray-500" data-id="element-3900">(2)</span>
                      </div>
                    </td>
                  </tr>
                  <tr className="border-b border-gray-100 hover:bg-gray-50/50 transition-colors" data-id="element-3901">
                    <td className="sticky left-0 z-10 bg-white py-3 px-4 text-left font-medium text-gray-700" data-id="element-3902">
                      <div className="flex items-center gap-2" data-id="element-3903">
                        <Shield size={14} className="text-emerald-500" data-id="element-3904" />
                        <div data-id="element-3905">
                          <span data-id="element-3906">Compliance Score</span>
                          <span className="block text-[10px] text-gray-400 font-normal" data-id="element-3907">
                            Higher is better
                          </span>
                        </div>
                      </div>
                    </td>
                    {filteredSites.map(site => {
                  const colors = getScoreColor(site.complianceScore);
                  return <td key={`compliance-score-${site.id}`} className={`py-3 px-3 text-center transition-colors ${hoveredColumn === site.id ? 'bg-gray-50' : ''}`} data-id="element-3908">
                          <div className="flex flex-col items-center gap-1" data-id="element-3909">
                            <span className={`inline-flex items-center justify-center min-w-[36px] h-6 px-2 rounded text-sm font-bold ${colors.bg} ${colors.text}`} data-id="element-3910">
                              {site.complianceScore}
                            </span>
                            <div className="w-full max-w-[60px] h-1.5 bg-gray-100 rounded-full overflow-hidden" data-id="element-3911">
                              <div className={`h-full ${colors.barBg} rounded-full transition-all duration-500`} style={{
                          width: `${site.complianceScore}%`
                        }} data-id="element-3912" />
                            </div>
                          </div>
                        </td>;
                })}
                  </tr>
                  <tr className="border-b-2 border-gray-200 hover:bg-gray-50/50 transition-colors" data-id="element-3913">
                    <td className="sticky left-0 z-10 bg-white py-3 px-4 text-left font-medium text-gray-700" data-id="element-3914">
                      <div className="flex items-center gap-2" data-id="element-3915">
                        <AlertTriangle size={14} className="text-orange-500" data-id="element-3916" />
                        <div data-id="element-3917">
                          <span data-id="element-3918">Risk Score</span>
                          <span className="block text-[10px] text-gray-400 font-normal" data-id="element-3919">
                            Lower is better
                          </span>
                        </div>
                      </div>
                    </td>
                    {filteredSites.map(site => {
                  const colors = getRiskColor(site.riskScore);
                  return <td key={`risk-score-${site.id}`} className={`py-3 px-3 text-center transition-colors ${hoveredColumn === site.id ? 'bg-gray-50' : ''}`} data-id="element-3920">
                          <div className="flex flex-col items-center gap-1" data-id="element-3921">
                            <span className={`inline-flex items-center justify-center min-w-[36px] h-6 px-2 rounded text-sm font-bold ${colors.bg} ${colors.text}`} data-id="element-3922">
                              {site.riskScore}
                            </span>
                            <div className="w-full max-w-[60px] h-1.5 bg-gray-100 rounded-full overflow-hidden flex justify-end" data-id="element-3923">
                              <div className={`h-full ${colors.barBg} rounded-full transition-all duration-500`} style={{
                          width: `${site.riskScore}%`
                        }} data-id="element-3924" />
                            </div>
                          </div>
                        </td>;
                })}
                  </tr>

                  {Object.entries(groupedMetrics).map(([category, metrics]) => {
                const isCollapsed = collapsedCategories.has(category);
                return <Fragment key={category} data-id="element-3925">
                        {/* Category Header Row */}
                        <tr className="bg-gray-50 border-t border-gray-200" data-id="element-3926">
                          <td colSpan={filteredSites.length + 1} className="sticky left-0 z-10 bg-gray-50" data-id="element-3927">
                            <button onClick={() => toggleCategory(category)} className="w-full flex items-center gap-2 py-3 px-4 text-left hover:bg-gray-100 transition-colors" data-id="element-3928">
                              <motion.div animate={{
                          rotate: isCollapsed ? 0 : 90
                        }} transition={{
                          duration: 0.2
                        }} data-id="element-3929">
                                <ChevronDown size={16} className="text-gray-500" data-id="element-3930" />
                              </motion.div>
                              <span className="text-xs font-bold text-gray-700 uppercase tracking-wider" data-id="element-3931">
                                {CATEGORY_LABELS[category as keyof typeof CATEGORY_LABELS]}
                              </span>
                              <span className="text-xs text-gray-500" data-id="element-3932">
                                ({metrics.length})
                              </span>
                            </button>
                          </td>
                        </tr>

                        {/* Metric Rows */}
                        <AnimatePresence initial={false} data-id="element-3933">
                          {!isCollapsed && metrics.map((metric, idx) => <motion.tr key={metric.id} initial={{
                      opacity: 0,
                      height: 0
                    }} animate={{
                      opacity: 1,
                      height: 'auto'
                    }} exit={{
                      opacity: 0,
                      height: 0
                    }} transition={{
                      duration: 0.2,
                      delay: idx * 0.02
                    }} className="border-b border-gray-100 hover:bg-gray-50/50 transition-colors" data-id="element-3934">
                                <td className="sticky left-0 z-10 bg-white py-3 px-4 text-left font-medium text-gray-700" data-id="element-3935">
                                  <div className="flex items-center gap-2" data-id="element-3936">
                                    {metric.label}
                                    {isContractorFiltered && metric.contractorIgnored && <span className="inline-flex items-center gap-1 bg-gray-100 text-gray-500 text-[10px] font-semibold px-1.5 py-0.5 rounded-full whitespace-nowrap" data-id="element-3937">
                                          <Info size={9} data-id="element-3938" />
                                          Not contractor-specific
                                        </span>}
                                  </div>
                                </td>
                                {filteredSites.map(site => <td key={`${metric.id}-${site.id}`} className={`py-3 px-3 text-center transition-colors ${hoveredColumn === site.id ? 'bg-gray-50' : ''}`} data-id="element-3939">
                                    {renderCell(metric.getValue(site), metric.type, metric.getLink ? metric.getLink(site) : undefined)}
                                  </td>)}
                              </motion.tr>)}
                        </AnimatePresence>
                      </Fragment>;
              })}
                </tbody>
              </table>
            </motion.div> : <motion.div key="feature-adoption" initial={{
          opacity: 0,
          y: 10
        }} animate={{
          opacity: 1,
          y: 0
        }} exit={{
          opacity: 0,
          y: -10
        }} transition={{
          duration: 0.2
        }} data-id="element-3940">
              <table className="w-full text-sm border-collapse" data-id="element-3941">
                {/* Header Row - Project Names */}
                <thead className="sticky top-0 z-20 bg-white" data-id="element-3942">
                  <tr className="border-b-2 border-gray-200" data-id="element-3943">
                    <th className="sticky left-0 z-30 bg-white py-4 px-4 text-left min-w-[240px]" data-id="element-3944">
                      <span className="text-xs font-semibold text-gray-500 uppercase tracking-wider" data-id="element-3945">
                        Feature
                      </span>
                    </th>
                    {filteredProjects.map(project => <th key={project.id} className="py-4 px-3 text-center min-w-[140px]" data-id="element-3946">
                        <span className="text-sm font-bold text-gray-900" data-id="element-3947">
                          {project.projectName}
                        </span>
                      </th>)}
                  </tr>
                </thead>

                <tbody data-id="element-3948">
                  {Object.entries(FEATURE_LABELS).map(([key, label]) => <tr key={key} className="border-b border-gray-100 hover:bg-gray-50/50 transition-colors" data-id="element-3949">
                      <td className="sticky left-0 z-10 bg-white py-4 px-4 text-left font-medium text-gray-700" data-id="element-3950">
                        {label}
                      </td>
                      {filteredProjects.map(project => <td key={`${key}-${project.id}`} className="py-4 px-3 text-center" data-id="element-3951">
                          {renderFeatureStatus(project.features[key as keyof FeatureAdoption] as 'active' | 'partial' | 'inactive')}
                        </td>)}
                    </tr>)}

                  {/* Comment Row */}
                  <tr className="border-t-2 border-gray-200 bg-gray-50" data-id="element-3952">
                    <td className="sticky left-0 z-10 bg-gray-50 py-4 px-4 text-left font-bold text-gray-900" data-id="element-3953">
                      Comment
                    </td>
                    {filteredProjects.map(project => <td key={`comment-${project.id}`} className="py-4 px-3 text-left" data-id="element-3954">
                        {project.features.comment ? <div className="text-xs text-gray-700 whitespace-pre-line" data-id="element-3955">
                            {project.features.comment}
                          </div> : <span className="text-xs text-gray-400" data-id="element-3956">-</span>}
                      </td>)}
                  </tr>
                </tbody>
              </table>
            </motion.div>}
        </AnimatePresence>
      </div>

      {/* Animated Scroll Indicator */}
      <AnimatePresence data-id="element-3957">
        {showScrollIndicator && <motion.div initial={{
        opacity: 0,
        y: -10
      }} animate={{
        opacity: 1,
        y: 0
      }} exit={{
        opacity: 0,
        y: -10
      }} transition={{
        duration: 0.3
      }} className="absolute bottom-0 left-0 right-0 h-20 pointer-events-none flex items-end justify-center pb-4" style={{
        background: 'linear-gradient(to top, rgba(255,255,255,0.95) 0%, rgba(255,255,255,0) 100%)'
      }} data-id="element-3958">
            <motion.div animate={{
          y: [0, 8, 0]
        }} transition={{
          duration: 1.5,
          repeat: Infinity,
          ease: 'easeInOut'
        }} className="flex flex-col items-center gap-1" data-id="element-3959">
              <div className="flex flex-col gap-0.5" data-id="element-3960">
                <motion.div animate={{
              opacity: [0.3, 1, 0.3]
            }} transition={{
              duration: 1.5,
              repeat: Infinity,
              ease: 'easeInOut',
              delay: 0
            }} className="w-1 h-1 bg-gray-400 rounded-full" data-id="element-3961" />
                <motion.div animate={{
              opacity: [0.3, 1, 0.3]
            }} transition={{
              duration: 1.5,
              repeat: Infinity,
              ease: 'easeInOut',
              delay: 0.2
            }} className="w-1 h-1 bg-gray-400 rounded-full" data-id="element-3962" />
                <motion.div animate={{
              opacity: [0.3, 1, 0.3]
            }} transition={{
              duration: 1.5,
              repeat: Infinity,
              ease: 'easeInOut',
              delay: 0.4
            }} className="w-1 h-1 bg-gray-400 rounded-full" data-id="element-3963" />
              </div>
              <span className="text-xs text-gray-500 font-medium" data-id="element-3964">
                Scroll for more
              </span>
            </motion.div>
          </motion.div>}
      </AnimatePresence>
    </Card>;
}